import { render, staticRenderFns } from "./shift-view-changes-history.vue?vue&type=template&id=02156b7a&"
import script from "./shift-view-changes-history.vue?vue&type=script&lang=js&"
export * from "./shift-view-changes-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports